import { Switch } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useApplicationTable } from 'applicationTable/ApplicationTable.context';
import { useApplicationTableState } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import styles from './ManagedByIwocaSwitch.module.css';

export const ManagedByIwocaSwitch = () => {
  const { searchApplicationPartnerChannelToggle } = useApplicationTable();

  const { includePartnerChannel, setIncludePartnerChannel } =
    useApplicationTableState();

  const handleChange = (prevValue: boolean) => {
    setIncludePartnerChannel(!prevValue);
    searchApplicationPartnerChannelToggle(!prevValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.toggleContainer}>
        <h3 className={styles.heading}>
          <Trans>Show managed by iwoca apps</Trans>
        </h3>
        <Switch
          data-testid="managed-by-iwoca-switch"
          checked={includePartnerChannel}
          onClick={() => handleChange(includePartnerChannel)}
        />
      </div>
      <p className={styles.subHeading}>
        <Trans>
          These applications are managed by iwoca and can only be viewed.
        </Trans>
      </p>
    </div>
  );
};
